import axios from 'utils/axios';
import * as ActionTypes from './actions';

export function backlogHasErrored(error) {
    return {
        type: ActionTypes.LOAD_BACKLOG_ERROR,
        error
    };
}
export function backlogIsLoading(bool) {
    return {
        type: ActionTypes.LOAD_BACKLOG_LOADING,
        loading: bool
    };
}
export function backlogFetchDataSuccess(data) {
    return {
        type: ActionTypes.LOAD_BACKLOG_SUCCESS,
        data
    };
}
export function filterData(filterSearch) {
    return {
        type: ActionTypes.FILTER_BACKLOG,
        filterSearch
    };
}

export function backlogFetchData() {
    return (dispatch) => {
        dispatch(backlogIsLoading(true));
        axios
            .get('/backlog-tweet/get-latest')
            .then((response) => {
                dispatch(backlogIsLoading(false));
                return response;
            })
            .then((response) => response.data)
            .then((data) => dispatch(backlogFetchDataSuccess(data)))
            .catch((error) => dispatch(backlogHasErrored(error)));
    };
}
